require('../../modules/es6.reflect.delete-property');
module.exports = require('../../modules/_core').Reflect.deleteProperty;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/delete-property.js
// module id = 689
// module chunks = 1